module.exports = __webpack_public_path__ + "img/amt-logo-white-h200.551fbe24.png";